import styled from 'styled-components'
import { useWorld } from '../hooks/use-world'
import { useEffect, useState } from 'react'

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 2rem;
  right: 2rem;
  transform: translateY(-50%);
  min-height: 5rem;
  background: ${({ theme }) => theme.colors('background', 0.92)};
  border: 1px solid ${({ theme }) => theme.colors('foreground', 0.2)};
  color: ${({ theme }) => theme.colors('text')};
  font-family: 'Silkscreen', monospace;
  font-size: 0.8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  z-index: 1010;
  pointer-events: none;
`

const Prompt = styled.div`
  font-size: 0.6rem;
  color: ${({ theme }) => theme.colors('foreground', 0.45)};
  margin-top: 0.5rem;
  pointer-events: auto;
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.colors('text')};
  }
`

export const Terminal = () => {
  const [text, setText] = useState()
  const { dialog, setDialog } = useWorld()

  const handler = () => {
    const d = [...dialog]
    d.shift()
    setDialog(d)
  }

  useEffect(() => {
    setText(dialog[0])
  }, [dialog])

  if (dialog.length === 0) return null

  return (
    <Container>
      <div>{text}</div>
      <Prompt onClick={handler}>[ click to continue ]</Prompt>
    </Container>
  )
}
